import { getMonyawnKicker } from "../../../../utils/helpers";
import { LeverageIndicator } from "../../../panels/LeverageIndicator/LeverageIndicator";
import { PrivacyGuard } from "../../../panels/PrivacyGuard/PrivacyGuard";
import { StatusNotice } from "../../../ui/StatusNotice";
import { AiAutopilotPanel } from "../../../panels/AiAutopilotPanel/AiAutopilotPanel";
import { HeroSectionProps } from "./HeroSection.contract";

export function HeroSection({
  currentMode,
  completionScore,
  currentStage,
  notice,
  guardResult,
  isCloseLostDisabled,
  onAdvanceStage,
  onExport,
  onPremiumDiligencePacketExport,
  onSharePlay,
  onCloseLost,
  onResetSeedState,
}: HeroSectionProps) {
  return (
    <section
      className="grid grid-cols-1 xl:grid-cols-[minmax(0,1.18fr)_minmax(340px,0.82fr)] gap-8 xl:gap-10 items-start mb-10"
      aria-labelledby="hero-title"
    >
      <div className="flex flex-col gap-5 w-full">
        <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-brand-accent">
          {currentMode === "user" ? "Chat play" : getMonyawnKicker()}
        </p>
        <h1
          id="hero-title"
          className="text-3xl sm:text-4xl lg:text-5xl xl:text-[3.35rem] font-extrabold text-brand-ink leading-[0.98] tracking-[-0.04em]"
        >
          The money cockpit. You drive, we clear the lane.
        </h1>
        <p className="text-base lg:text-lg text-brand-muted leading-relaxed max-w-[68ch]">
          One thread. Every move. Your proof, your messages, and your story - all in order.
        </p>

        <div className="flex flex-wrap gap-3 mt-2">
          <button
            className={`px-5 py-2 rounded-xl font-bold transition-all shadow-sm active:scale-95 text-sm ${
              guardResult.passed
                ? "bg-brand-accent text-white hover:bg-brand-accent-strong"
                : "bg-gray-200 text-gray-400 cursor-not-allowed"
            }`}
            type="button"
            onClick={onAdvanceStage}
            disabled={!guardResult.passed}
            title={guardResult.passed ? "Level up the play" : guardResult.failures.join(", ")}
          >
            {guardResult.passed ? "Level up the play" : "Evidence required"}
          </button>
          <div className="flex flex-wrap items-center gap-2 rounded-xl border border-black/10 bg-white/60 px-2 py-2">
            <button
              className="bg-brand-surface border border-black/10 text-brand-ink px-4 py-2 rounded-xl font-medium hover:bg-black/5 transition-all active:scale-95 text-sm"
              type="button"
              onClick={onExport}
            >
              Export ZIP
            </button>
            <button
              className="text-brand-muted px-3 py-2 text-sm font-semibold hover:text-brand-ink transition-colors"
              type="button"
              onClick={onPremiumDiligencePacketExport}
            >
              Premium PDF
            </button>
            <button
              className="text-brand-muted px-3 py-2 text-sm font-semibold hover:text-brand-ink transition-colors"
              type="button"
              onClick={onSharePlay}
            >
              Share
            </button>
          </div>
          <button
            className="bg-brand-surface border border-black/10 text-brand-ink px-5 py-2 rounded-xl font-medium hover:bg-black/5 transition-all active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed text-sm"
            type="button"
            onClick={onCloseLost}
            disabled={isCloseLostDisabled}
          >
            Mark it dead
          </button>
        </div>

        {notice && <StatusNotice tone={notice.tone} message={notice.message} />}

        <details className="rounded-2xl border border-black/10 bg-brand-surface px-4 py-3 w-fit">
          <summary className="cursor-pointer text-[10px] font-bold uppercase tracking-[0.18em] text-brand-muted">
            Dev tools
          </summary>
          <button
            className="mt-3 bg-brand-surface border border-black/10 text-brand-ink px-4 py-2 rounded-full text-xs font-semibold hover:bg-black/5 transition-all"
            type="button"
            onClick={onResetSeedState}
          >
            Reset the mock bag
          </button>
        </details>
      </div>

      <div className="grid grid-cols-1 gap-4 xl:sticky xl:top-24">
        <PrivacyGuard />
        <LeverageIndicator
          score={completionScore}
          label={currentStage}
          isComplete={completionScore === 100}
        />
        <AiAutopilotPanel />
      </div>
    </section>
  );
}
